import { FC } from "react";
import { useTranslation } from "react-i18next";
import ShareSiteBinCards from "./ShareSiteBinCards";
import { StoragesValuesView } from "../../../../redux/slices/grainTracker/grainTrackerTypes";
import ShareSiteFilters from "./ShareSiteFilters";
import {
  FetchingSharingStatusData,
  ListOfSpeciesData,
  ListTypeOfData,
  StoragesData,
} from "../../../../redux/slices/shareSite/shareSiteTypes";
import { LoadingCircularProgress } from "../../../Loading";

type ShareSiteBinCardsParams = {
  storages: StoragesValuesView[];
  setSelectedStoragesIds: (values: string[]) => void;
  selectedStoragesIds: string[];

  setSelectSpecieFilter: (value: number) => void;
  selectedSpecie: number;
  listOfSpeciesFilter: ListOfSpeciesData[];
  listOfSpeciesLoading: boolean;
  storagesLoading: boolean;
  noSpecieSelected: number;

  setSelectTypeOfFilter: (value: string) => void;
  typeSelected: string;
  listTypeOfFilter: ListTypeOfData[];

  infiniteId: number;

  setToKeep: (values: string[]) => void;
  setToDelete: (values: string[]) => void;

  toDelete: string[];
  toKeep: string[];

  sharingStatus: FetchingSharingStatusData;
  storageSharingLoading: boolean;
  storageSharedDeleteLoading: boolean;

  listTypeOfLoading: boolean;

    setStorages: (values: StoragesData) => void;
    setSelectedSort: (values: string) => void;
    storagesData: StoragesData;
    selectedSort: string;
};

const ShareSiteStoragesSelection: FC<ShareSiteBinCardsParams> = ({
  storages,
  setSelectedStoragesIds,
  selectedStoragesIds,
  setSelectSpecieFilter,
  selectedSpecie,
  listOfSpeciesFilter,
  storagesLoading,
  noSpecieSelected,
  setSelectTypeOfFilter,
  typeSelected,
  listTypeOfFilter,
  infiniteId,
  setToKeep,
  setToDelete,
  toDelete,
  toKeep,
  sharingStatus,
  listOfSpeciesLoading,
  storageSharedDeleteLoading,
  storageSharingLoading,
  listTypeOfLoading,
  setStorages,
  setSelectedSort,
  storagesData,
  selectedSort,
}) => {
  const [t] = useTranslation("global");

  return (
    <div className="share-site-storages-selection-container">
      <div>
        <div className="share-site-storages-selection-title">
          {t("Share_site.question-text-2")}
        </div>
        <div className="share-site-storages-selection-subtitle">
          {t("Share_site.description-text2")}
        </div>
      </div>

      <div>
        <div>
          <ShareSiteFilters
            setSelectSpecieFilter={setSelectSpecieFilter}
            selectedSpecie={selectedSpecie}
            listOfSpeciesFilter={listOfSpeciesFilter}
            setSelectTypeOfFilter={setSelectTypeOfFilter}
            typeSelected={typeSelected}
            listTypeOfFilter={listTypeOfFilter}
            setSelectedStoragesIds={setSelectedStoragesIds}
            storages={storages}
            listOfSpeciesLoading={listOfSpeciesLoading}
            storagesLoading={storagesLoading}
            storageSharedDeleteLoading={storageSharedDeleteLoading}
            storageSharingLoading={storageSharingLoading}
            listTypeOfLoading={listTypeOfLoading}
            setToDelete={setToDelete}
            sharingStatus={sharingStatus}
            selectedStoragesIds={selectedStoragesIds}
            setStorages={setStorages}
            setSelectedSort={setSelectedSort}
            storagesData={storagesData}
            selectedSort={selectedSort}
          />
        </div>
      </div>

      <div className="share-site-storages-selection-container-storages">
        {selectedSpecie !== noSpecieSelected && !storagesLoading ? (
          <ShareSiteBinCards
            storages={storages}
            selectedStoragesIds={selectedStoragesIds}
            setSelectedStoragesIds={setSelectedStoragesIds}
            selectedSpecie={selectedSpecie}
            selectedType={typeSelected}
            infiniteId={infiniteId}
            setToKeep={setToKeep}
            setToDelete={setToDelete}
            toDelete={toDelete}
            toKeep={toDelete}
            sharingStatus={sharingStatus}
          />
        ) : (
          <LoadingCircularProgress />
        )}
      </div>
    </div>
  );
};

export default ShareSiteStoragesSelection;
